/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Intro_Stat_FasterInputs */

const es_home_intro_stat_faster = /** @type {(inputs: Home_Intro_Stat_FasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`más rápido que búsqueda manual`)
};

const en_home_intro_stat_faster = /** @type {(inputs: Home_Intro_Stat_FasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`faster than manual search`)
};

/**
* | output |
* | --- |
* | "faster than manual search" |
*
* @param {Home_Intro_Stat_FasterInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_intro_stat_faster = /** @type {((inputs?: Home_Intro_Stat_FasterInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Intro_Stat_FasterInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_intro_stat_faster(inputs)
	return en_home_intro_stat_faster(inputs)
});
export { home_intro_stat_faster as "home.intro.stat_faster" }